// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* server/features/telegram/components/DeleteMarksModal.module.css */
.DeleteMarksModal_backdrop__TQeQD {
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0,0,0,0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2000;
}
.DeleteMarksModal_modal__CKGNe {
  background: #fff;
  padding: 24px;
  border-radius: 8px;
  width: 320px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.2);
}
.DeleteMarksModal_title__hkMBG {
  margin: 0 0 16px;
  font-size: 18px;
  color: #c00;
  text-align: center;
}
.DeleteMarksModal_fieldGroup__EcIFJ {
  display: flex;
  flex-direction: column;
  margin-bottom: 12px;
}
.DeleteMarksModal_label__ewyU5 {
  margin-bottom: 4px;
  font-size: 14px;
  color: #333;
}
.DeleteMarksModal_input__FIjeW {
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
}
.DeleteMarksModal_actions__C-8EI {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 16px;
}
.DeleteMarksModal_button__pvWO\\+ {
  padding: 8px 12px;
  border: none;
  border-radius: 4px;
  background: #007acc;
  color: #fff;
  cursor: pointer;
}
.DeleteMarksModal_buttonDanger__uk5yQ {
  padding: 8px 12px;
  border: none;
  border-radius: 4px;
  background: #c00;
  color: #fff;
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/modules/Developer/TestPages/Marks/components/DeleteMarksModal.module.css"],"names":[],"mappings":"AAAA,oEAAoE;AACpE;EACE,eAAe;EACf,MAAM,EAAE,OAAO,EAAE,QAAQ,EAAE,SAAS;EACpC,2BAA2B;EAC3B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,sCAAsC;AACxC;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;AACA;EACE,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;EACR,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB","sourcesContent":["/* server/features/telegram/components/DeleteMarksModal.module.css */\r\n.backdrop {\r\n  position: fixed;\r\n  top: 0; left: 0; right: 0; bottom: 0;\r\n  background: rgba(0,0,0,0.5);\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  z-index: 2000;\r\n}\r\n.modal {\r\n  background: #fff;\r\n  padding: 24px;\r\n  border-radius: 8px;\r\n  width: 320px;\r\n  box-shadow: 0 2px 10px rgba(0,0,0,0.2);\r\n}\r\n.title {\r\n  margin: 0 0 16px;\r\n  font-size: 18px;\r\n  color: #c00;\r\n  text-align: center;\r\n}\r\n.fieldGroup {\r\n  display: flex;\r\n  flex-direction: column;\r\n  margin-bottom: 12px;\r\n}\r\n.label {\r\n  margin-bottom: 4px;\r\n  font-size: 14px;\r\n  color: #333;\r\n}\r\n.input {\r\n  padding: 8px;\r\n  border: 1px solid #ccc;\r\n  border-radius: 4px;\r\n}\r\n.actions {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  gap: 8px;\r\n  margin-top: 16px;\r\n}\r\n.button {\r\n  padding: 8px 12px;\r\n  border: none;\r\n  border-radius: 4px;\r\n  background: #007acc;\r\n  color: #fff;\r\n  cursor: pointer;\r\n}\r\n.buttonDanger {\r\n  padding: 8px 12px;\r\n  border: none;\r\n  border-radius: 4px;\r\n  background: #c00;\r\n  color: #fff;\r\n  cursor: pointer;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"backdrop": `DeleteMarksModal_backdrop__TQeQD`,
	"modal": `DeleteMarksModal_modal__CKGNe`,
	"title": `DeleteMarksModal_title__hkMBG`,
	"fieldGroup": `DeleteMarksModal_fieldGroup__EcIFJ`,
	"label": `DeleteMarksModal_label__ewyU5`,
	"input": `DeleteMarksModal_input__FIjeW`,
	"actions": `DeleteMarksModal_actions__C-8EI`,
	"button": `DeleteMarksModal_button__pvWO+`,
	"buttonDanger": `DeleteMarksModal_buttonDanger__uk5yQ`
};
export default ___CSS_LOADER_EXPORT___;
